import { Outlet, Link } from 'react-router-dom';
import { Camera, Waves, UserCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function MainLayout() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen flex flex-col font-sans text-slate-900 bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-600">
              <Waves className="h-6 w-6" />
              <span>SurfSnaps</span>
            </Link>
            
            <nav className="flex items-center gap-4">
              <Link to="/surfer" className="text-sm font-medium hover:text-blue-600 px-3 py-2 rounded-md transition-colors">Find Photos</Link>
              <Link to="/photographer" className="text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 px-4 py-2 rounded-md transition-colors flex items-center gap-2">
                <Camera className="h-4 w-4" />
                Sell Photos
              </Link>
              {user && (
                <Link
                  to="/profile"
                  className="text-sm font-medium hover:text-blue-600 px-3 py-2 rounded-md transition-colors flex items-center gap-1.5"
                >
                  <UserCircle className="h-4 w-4" />
                  {user.name.split(' ')[0]}
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>

      <footer className="bg-slate-100 border-t border-slate-200 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-500 text-sm">
          &copy; {new Date().getFullYear()} SurfSnaps. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
